export default __webpack_public_path__ + "static/media/alphabet-yellow-p.48e8c7cd.png";